/**
 * Die stille Zeile in „Mehr“ (Handy) und im Menü ☰ (Rechner): was es geben muss, nicht was beworben
 * wird (28.10.2026). Für Veranstalter, Für Partner und Logo & Verlinkung stehen hier nicht; zusammen
 * kamen sie in 90 Tagen auf rund 240 Sitzungen. Eine Fußzeile gibt es seit dem 30.10.2026 nicht
 * mehr, dieses Menü ist damit der Weg zu Impressum und Datenschutz von jeder Seite.
 */
export const PFLICHT_LINKS: { label: string; to: string }[] = [
  { label: 'Impressum', to: '/impressum' },
  { label: 'Datenschutz', to: '/datenschutz' },
  { label: 'Kontakt', to: '/kontakt' },
  { label: 'Über uns', to: '/ueber-uns' },
];
